import {
  GENERATE_AI_PHOTO,
  DOWNLOAD_AI_PHOTO,
  INIT_AI_DOWNLOADS,
  UPDATE_REMAINING_DOWNLOADS,
} from './constants';

export function initAIDownloads(req) {
  return {
    type: INIT_AI_DOWNLOADS,
    req,
  };
}

export function generateAIPhoto(api) {
  return {
    type: GENERATE_AI_PHOTO,
    api,
  };
}

export function downloadAIPhoto(payload, api) {
  return {
    type: DOWNLOAD_AI_PHOTO,
    payload,
    api,
  };
}

export function updateRemainingDownloads(payload) {
  return {
    type: UPDATE_REMAINING_DOWNLOADS,
    payload,
  };
}
